module.exports = __webpack_public_path__ + "static/scale-model-of-spanish-town-historic-district-in-baton-rouge-louisiana-1e2325b5ca1fb67a131e666e7507907d.png";